import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import classNames from 'classnames';
import Cookies from 'js-cookie';
import routeConfiguration from '../../routeConfiguration';
import config from '../../config';
import { apiBaseUrl } from '../../util/api';
import { pathByRouteName } from '../../util/routes';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { parse } from '../../util/urlHelpers';
import LogoImage from '../../assets/logos/logo-white-horizon.svg';
import LogoImageWhite from '../../assets/logos/newLogo.png';
import { gSend, GTAG_ACTIONS, GTAG_METHODS } from '../../util/gtag';

import {
  isCaptchaError,
  isReferralCodeInvalid,
  isSignUpCodeInvalid,
  isSignupEmailTakenError,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import {
  IconClose,
  IconEmailSent,
  InlineTextButton,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Modal,
  NamedLink,
  NamedRedirect,
  Page,
  TermsOfService,
} from '../../components';
import { ConfirmSingupForm, LoginForm, SignupForm, SignupFormStep2 } from '../../forms';
import {
  authenticationInProgress,
  login,
  loginRequest,
  signup,
  signupStep1Success,
  signupWithIdp,
  update,
} from '../../ducks/Auth.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { pushGTMBrowseEvent, pushGTMSignupForm } from '../../util/gtm/gtmHelpers';
import { createRawPropertiesForGTM, getEventsByBucket } from '../../util/gtm/gtmCreateProperties';
import {
  CREATE_NEW_ACCOUNT_BUTTON_ID,
  EVENT_BROWSE_LOGGEDIN,
  EVENT_SIGNUP_COMPLETED,
  EVENT_SIGNUP_COMPLETED_STEP2,
  EVENT_SIGNUP_OPEN_EMAIL_FORM,
  EVENT_SIGNUP_OPEN_FORM,
  EVENT_SIGNUP_SOCIAL_FACEBOOK,
  EVENT_SIGNUP_SOCIAL_GOOGLE,
  EVENT_SIGNUP_SUBMIT_EMAIL_FORM,
  EVENT_SIGNUP_SUBMIT_FORM,
  SIGNUP_SUBMIT_BUTTON_ID,
  SIGNUP_UPDATE_SUBMIT_BUTTON_ID,
} from '../../util/gtm/gtmConstants';
import css from './AuthenticationPage.css';
import { checkIfReferralCode } from '../../util/referralProgram';
import { get } from 'lodash';
import leftImage from '../../assets/newSignUpDesign/hourlyHero2.jpg';
import confirmLeftImage from '../../assets/step_2.jpg';
import { triggerAnalyticsEvent } from '../../util/amplitudeMapEvents';
import { event_trigger_ids } from '../../util/analyticsConstants';

export class AuthenticationPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tosModalOpen: false,
      isReferralInvalid: false,
      data: null,
      newAuth: false,
      authError: Cookies.get('st-autherror')
        ? JSON.parse(Cookies.get('st-autherror').replace('j:', ''))
        : null,
      authInfo: Cookies.get('st-authinfo')
        ? JSON.parse(Cookies.get('st-authinfo').replace('j:', ''))
        : null,
      shouldShowReferralCodeLoadingScrn: false,
      isLoginPage: true,
      referralCode: null,
      gtmEvents: []
    };
  }

  async componentDidMount() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());
  
    if (queryParams && queryParams.code && typeof window !== 'undefined') {
      window.localStorage.setItem('code', queryParams.code);
    }
  
    if (typeof window !== 'undefined') {
      const code = window.localStorage.getItem('code');
      if (code) {
        this.setState({ referralCode: code });
      }
    }
  
    const { isAuthenticated, tab } = this.props;
    try {
      const response = await getEventsByBucket('signup');
      // console.log('Events fetched successfully:', response.data);
  
      this.setState({ gtmEvents: response.data });
      // console.log("GTM Events ssssssssssss", !isAuthenticated && tab === 'signup')
      if (!isAuthenticated && tab === 'signup') {
        // Get the current page URL
        // Pass the current page URL along with the button
        triggerAnalyticsEvent({
          event_id: event_trigger_ids.SIGN_UP_FORM_OPEN, 
          eventData: response.data, 
          props: {
            // referralCode: this.state.referralCode, 
            // ...this.props, 
            ui: {
              button: CREATE_NEW_ACCOUNT_BUTTON_ID,
              page: 'WelcomeScreen'
            },
            signup : {
              code: this.state.referralCode
            }
            // Pass the current page URL
          }
        });
        Cookies.remove('st-autherror');
      }
    } catch (error) {
      console.log('Error fetching events:', error);
    }
  
    // Remove the autherror cookie once the content is saved to state
    // because we don't want to show the error message e.g. after page refresh
    Cookies.remove('st-autherror');
  }
  

  render() {
    const {
      authInProgress,
      currentUser,
      intl,
      isAuthenticated,
      location,
      submitSignupWithIdp,
      loginError,
      scrollingDisabled,
      signupError,
      submitLogin,
      history,
      submitSignup,
      signupSuccess,
      submitSignupStep1,
      tab,
      state,
      submitUpdate,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      onResendVerificationEmail,
      requestLogin,
      onManageDisableScrolling,
      confirmError,
    } = this.props;
    let error;
    const isConfirm = tab === 'confirm';
    const isLogin = tab === 'login';
    const isSignup = tab === 'signup';
    const locationFrom = location.state && location.state.from ? location.state.from : null;
    const authinfoFrom =
      this.state.authInfo && this.state.authInfo.from ? this.state.authInfo.from : null;
    const from = locationFrom ? locationFrom : authinfoFrom ? authinfoFrom : null;
    const isFromListingPage = location.state && location.state.isFromListingPage;
    const isFromCampaign = !!parse(location.search).campaign;
    const signUpCode = parse(location.search).code;

    const { email: signUpEmail = null, password = null } = get(location, 'state', {}) || {};

    const user = ensureCurrentUser(currentUser);
    const currentUserLoaded = !!user.id;

    const shouldRedirect = user.id && user.attributes.profile.protectedData.phoneNumber;

    if (isAuthenticated && isFromListingPage && shouldRedirect) {
      return (
        <NamedRedirect name="ListingPage" state={location.state} params={location.state.params} />
      );
    }

    // We only want to show the email verification dialog in the signup
    // tab if the user isn't being redirected somewhere else
    // (i.e. `from` is present). We must also check the `emailVerified`
    // flag only when the current user is fully loaded.
    const showEmailVerification = !isLogin && currentUserLoaded && !user.attributes.emailVerified;

    // Already authenticated, redirect away from auth page
    if (isAuthenticated && from) {
      return <Redirect to={from} />;
    } else if (isAuthenticated && currentUserLoaded) {
      return <NamedRedirect name="LandingPage" />;
    }

    // if (isAuthenticated && isFromListingPage) {
    //   return (
    //     <NamedRedirect name="ListingPage" state={location.state} params={location.state.params} />
    //   );
    // }

    const handleChange = value => {
      this.setState({ isLoginPage: value });
    };

    const handleSubmitUpdate = values => {
      // const params = { firstName: fname.trim(), lastName: lname.trim(), ...rest };
      submitUpdate(values);
      const properties = createRawPropertiesForGTM({
        props: this.props,
        button: {
          buttonId: SIGNUP_UPDATE_SUBMIT_BUTTON_ID,
        },
      });
      // pushGTMSignupForm(properties, EVENT_SIGNUP_COMPLETED_STEP2);
      // this.setState({initPage: true})
    };

    // if (signupError) {
    //   // error = <p>{signupError?.apiErrors[0].title}</p>
    // }
    // const aaa = signupError ? pathByRouteName('SignupUpdatePage', routeConfiguration()) : null;
    // Already authenticated, redirect away from auth page
    // if (isAuthenticated && from) {
    //   return <Redirect to={from} />;
    // } else if (isAuthenticated && currentUserLoaded && !showEmailVerification) {
    //   if (window && signUpCode && checkIfReferralCode(signUpCode)) {
    //     window.alert('You can only use the referral link when you are not logged in');
    //   }
    //   return <NamedRedirect name="LandingPage" />;
    // }
    // if (isAuthenticated && loginTab) {
    //   return (
    //     <NamedRedirect name="LandingPage" />
    //   );
    //     }
    const loginErrorMessage = (
      <div className={css.error}>
        <FormattedMessage id="AuthenticationPage.loginFailed" />
      </div>
    );

    const signupErrorMessage = (
      <div className={css.error}>
        {isSignUpCodeInvalid(signupError) && (
          <FormattedMessage id="AuthenticationPage.SignUpCodeInvalid" />
        )}
        {isSignupEmailTakenError(signupError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : isCaptchaError(signupError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedCaptcha" />
        ) : (
          <FormattedMessage id="AuthenticationPage.signupFailed" />
        )}
      </div>
    );
    const confirmErrorMessage = confirmError ? (
      <div className={css.error}>
        {isSignupEmailTakenError(confirmError) ? (
          <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
        ) : isReferralCodeInvalid(confirmError) ? (
          <FormattedMessage id="AuthenticationPage.referralError" />
        ) : (
          <FormattedMessage
            id="AuthenticationPage.signupConflictError"
            values={{
              link: (
                <NamedLink name={'LoginPage'}>
                  <FormattedMessage id={'AuthenticationPage.loginLink'} />
                </NamedLink>
              ),
            }}
          />
        )}
      </div>
    ) : null;

    // eslint-disable-next-line no-confusing-arrow
    const errorMessage = (error, message) => (error ? message : null);
    const loginOrSignupError = isLogin
      ? errorMessage(loginError, loginErrorMessage)
      : errorMessage(signupError, signupErrorMessage);

    const fromState = {
      state: from ? { from } : null,
      search: signUpCode ? `code=${signUpCode}` : null,
    };

    const handleSubmitSignup = values => {
      const { fname, lname, ...rest } = values;
      const params = { firstName: fname.trim(), lastName: lname.trim(), ...rest };
      submitSignup(params);
      localStorage.setItem('step2', true);
      const properties = createRawPropertiesForGTM({
        props: this.props,
        button: {
          buttonId: SIGNUP_SUBMIT_BUTTON_ID,
        },
      });
      // pushGTMSignupForm(properties, EVENT_SIGNUP_OPEN_EMAIL_FORM);
      // pushGTMSignupForm(properties, EVENT_SIGNUP_SUBMIT_EMAIL_FORM);
      // pushGTMSignupForm(properties, EVENT_SIGNUP_COMPLETED);
      gSend(GTAG_ACTIONS.ACTION_SIGNUP, { method: GTAG_METHODS.WEB_SIGNUP });
    };

    const handleSubmitConfirm = values => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const queryParams = Object.fromEntries(urlSearchParams.entries());
      const { idpToken, idpId } = queryParams;
      // localStorage.setItem('step2', true);
      const {
        email: newEmail,
        firstName: newFirstName,
        lastName: newLastName,
        // day,
        // month,
        // year,
        // gender,
        role,
        code,
        phoneCode,
        phoneNumber,
      } = values;

      // const dateOfBirth = {
      //   day: Number(day),
      //   month: Number(month),
      //   year: Number(year)
      // }

      requestLogin();

      // Pass email, fistName or lastName to Flex API only if user has edited them
      // sand they can't be fetched directly from idp provider (e.g. Facebook)

      let authParams = {
        email: newEmail,
        firstName: newFirstName,
        lastName: newLastName,
        protectedData: {
          // phoneNumber: phoneCode + phoneNumber,
          // phoneObj: {
          //   phoneCode,
          //   rawNumber: phoneNumber
          // },
          // dateOfBirth,
          // gender,
          role,
        },
        code,
      };

      // Handle the phone number if it's given
      if (phoneCode && phoneNumber) {
        authParams.protectedData.phoneNumber = `${phoneCode}${phoneNumber}`;
        authParams.protectedData.phoneObj = {
          phoneCode,
          rawNumber: phoneNumber
        };
      }

      // If the confirm form has any additional values, pass them forward as user's protected data
      // const protectedData = !isEmpty(rest) ? { ...rest } : null;

      submitSignupWithIdp({
        idpToken,
        idpId,
        ...authParams,
        // ...(!!protectedData && { protectedData }),
        callback: () => {
          return new Promise((resolve) => {
            const properties = createRawPropertiesForGTM({
              props: this.props,
              button: {
                buttonId: SIGNUP_UPDATE_SUBMIT_BUTTON_ID,
              },
            });
            if (idpId === 'facebook') {
              // pushGTMSignupForm(properties, EVENT_SIGNUP_SOCIAL_FACEBOOK);
              // pushGTMSignupForm(properties, EVENT_SIGNUP_COMPLETED);
              gSend(GTAG_ACTIONS.ACTION_SIGNUP, { method: GTAG_METHODS.FACEBOOK_SIGNUP });
            } else if (idpId === 'google') {
              // pushGTMSignupForm(properties, EVENT_SIGNUP_SOCIAL_GOOGLE);
              // pushGTMSignupForm(properties, EVENT_SIGNUP_COMPLETED);
              gSend(GTAG_ACTIONS.ACTION_SIGNUP, { method: GTAG_METHODS.GOOGLE_SIGNUP });
            }
            // pushGTMSignupForm(properties, EVENT_SIGNUP_COMPLETED_STEP2);
            setTimeout(() => { resolve(); }, 1000);
          });
        }
      });
    };

    const handleSubmitLogin = async values => {
      try {
        const res = await submitLogin(values);
        // console.log("Login response CCCCCCCCCCC", this.props.currentUser, currentUser);
        gSend(GTAG_ACTIONS.ACTION_LOGIN, { method: GTAG_METHODS.WEB_LOGIN });
    
        // Uncomment this if pushGTMBrowseEvent is needed
        // pushGTMBrowseEvent({
        //   props: this.props,
        //   event: EVENT_BROWSE_LOGGEDIN,
        // });
    
        const response = await getEventsByBucket('browsing');
        triggerAnalyticsEvent({ 
          event_id: event_trigger_ids.LOGGED_IN, 
          eventData: response.data,
          props: {
            ui: {
              button: 'Log in to your account',
              page: 'OnboardingScreen'
            }
          },
          userId: this.props.currentUser ? this.props.currentUser.id.uuid : null,
          user: this.props.currentUser
        });
      } catch (error) {
        console.error('Error during login:', error);
      }
    };
    

    const getDefaultRoutes = () => {
      const routes = routeConfiguration();
      const baseUrl = apiBaseUrl();

      // Route where the user should be returned after authentication
      // This is used e.g. with EditListingPage and ListingPage
      const fromParam = from ? `from=${from}` : '';

      // Default route where user is returned after successfull authentication
      const defaultReturn = pathByRouteName('LandingPage', routes);
      const defaultReturnParam = defaultReturn ? `&defaultReturn=${defaultReturn}` : '';

      // Route for confirming user data before creating a new user
      const defaultConfirm = pathByRouteName('ConfirmPage', routes);
      const defaultConfirmParam = defaultConfirm ? `&defaultConfirm=${defaultConfirm}` : '';

      return { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam };
    };
    const authWithFacebook = (action, method) => {
      const defaultRoutes = getDefaultRoutes();
      const { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam } = defaultRoutes;
      window.location.href = `${baseUrl}/api/auth/facebook?${fromParam}${defaultReturnParam}${defaultConfirmParam}`;
    };

    const authWithGoogle = (action, method) => {
      const defaultRoutes = getDefaultRoutes();
      const { baseUrl, fromParam, defaultReturnParam, defaultConfirmParam } = defaultRoutes;
      window.location.href = `${baseUrl}/api/auth/google?${fromParam}${defaultReturnParam}${defaultConfirmParam}`;
    };

    const idp = this.state.authInfo
      ? this.state.authInfo.idpId.replace(/^./, str => str.toUpperCase())
      : null;

    const urlSearchParams = new URLSearchParams(location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());

    const { email: userEmail, firstName, lastName } = queryParams;

    const initialValues = {
      email: userEmail,
      firstName,
      lastName,
      code: this.state.referralCode,
      phoneCode: '+65',
    };

    // Form for confirming information frm IdP (e.g. Facebook)
    // before new user is created to Flex
    const confirmForm = (
      <div className={css.confirmMobileWrapper}>
        <div className={css.authLogoSectionMobile}>
          <img onClick={() => (window.location.href = '/')} src={LogoImageWhite} alt="Drive lah logo" />
        </div>

        <div className={css.mobileWrapper}>
          <h1 className={css.confirmAuthPageTitle}>
            Tell us a bit more about
            <br />
            yourself
          </h1>
          {confirmErrorMessage}
              <div>
                <ConfirmSingupForm
                  isReferralInvalid={this.state.isReferralInvalid}
                  className={css.form}
                  location={location}
                  onSubmit={handleSubmitConfirm}
                  inProgress={authInProgress}
                  onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
                  authInfo={this.state.authInfo}
                  idp={idp}
                  initialValues={initialValues}
                />
              </div>
        </div>
      </div>
    );

    const facebookButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithFacebook" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithFacebook" />
    );

    const googleButtonText = isLogin ? (
      <FormattedMessage id="AuthenticationPage.loginWithGoogle" />
    ) : (
      <FormattedMessage id="AuthenticationPage.signupWithGoogle" />
    );

    const initEmail = parse(location.search).email;

    const name = user.attributes.profile.firstName;
    const email = <span className={css.email}>{user.attributes.email}</span>;

    const resendEmailLink = (
      <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
        <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
      </InlineTextButton>
    );
    const fixEmailLink = (
      <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
        <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
      </NamedLink>
    );

    const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
      sendVerificationEmailError
    )
      ? 'AuthenticationPage.resendFailedTooManyRequests'
      : 'AuthenticationPage.resendFailed';
    const resendErrorMessage = sendVerificationEmailError ? (
      <p className={css.error}>
        <FormattedMessage id={resendErrorTranslationId} />
      </p>
    ) : null;
    const authenticationForms = (
      <div className={css.content}>
        {/* <LinkTabNavHorizontal className={css.tabs} tabs={tabs} /> */}
        <div className={css.authLogoSection}>
          <img onClick={() => (window.location.href = '/')} src={LogoImage} alt="Drive lah logo" />
        </div>
        <div className={css.authLogoSectionMobile}>
          <img onClick={() => (window.location.href = '/')} src={LogoImageWhite} alt="" />
        </div>
        <div className={css.mobileWrapper}>
          <div className={css.authPageTitle}>
            {this.state.isLoginPage && tab === 'login' ? 'Welcome back' : 'Join Drive lah'}
          </div>

          {loginOrSignupError}
          {this.state.isLoginPage && tab === 'login' ? (
            <LoginForm
              className={css.form}
              google={() => authWithGoogle(GTAG_ACTIONS.ACTION_LOGIN, GTAG_METHODS.GOOGLE_LOGIN)}
              facebook={() => authWithFacebook(GTAG_ACTIONS.ACTION_LOGIN, GTAG_METHODS.FACEBOOK_LOGIN)}
              onSubmit={handleSubmitLogin}
              inProgress={authInProgress}
              handleChange={handleChange}
              location={location}
            />
          ) : signupSuccess ? (
            <SignupFormStep2
              className={css.form}
              onSubmit={data => handleSubmitUpdate({ ...data })}
              inProgress={authInProgress}
              submitButtonId={SIGNUP_UPDATE_SUBMIT_BUTTON_ID}
              handleChange={handleChange}
            />
          ) : (
            <div>
              {/* <p className={css.errorMessage}>{error}</p>{' '} */}
              <SignupForm
                className={css.form}
                onSubmit={data => {
                  handleSubmitSignup({ ...data, isFromCampaign: isFromCampaign });
                }}
                inProgress={authInProgress}
                google={() => authWithGoogle(GTAG_ACTIONS.ACTION_SIGNUP, GTAG_METHODS.GOOGLE_SIGNUP)}
                facebook={() => authWithFacebook(GTAG_ACTIONS.ACTION_SIGNUP, GTAG_METHODS.FACEBOOK_SIGNUP)}
                initEmail={initEmail || signUpEmail}
                onOpenTermsOfService={() => this.setState({ tosModalOpen: true })}
                submitButtonId={SIGNUP_SUBMIT_BUTTON_ID}
                initialValues={{ email: signUpEmail, password }}
                handleChange={handleChange}
                location={location}
                signupError={signupError}
              />
            </div>
          )}
        </div>
      </div>
    );

    // // const name = user.attributes.profile.firstName;
    //   // const email = <span className={css.email}>{user.attributes.email}</span>;

    //   const resendEmailLink = (
    //     <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
    //       <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
    //     </InlineTextButton>
    //   );
    //   const fixEmailLink = (
    //     <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
    //       <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
    //     </NamedLink>
    //   );

    //       const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
    //     sendVerificationEmailError
    //   )
    //     ? 'AuthenticationPage.resendFailedTooManyRequests'
    //     : 'AuthenticationPage.resendFailed';
    //   const resendErrorMessage = sendVerificationEmailError ? (
    //     <p className={css.error}>
    //       <FormattedMessage id={resendErrorTranslationId} />
    //     </p>
    //   ) : null;

    const emailVerificationContent = (
      <div className={css.content}>
        <NamedLink className={css.verifyClose} name="ProfileSettingsPage">
          <span className={css.closeText}>
            <FormattedMessage id="AuthenticationPage.verifyEmailClose" />
          </span>
          <IconClose rootClassName={css.closeIcon} />
        </NamedLink>
        <IconEmailSent className={css.modalIcon} />
        <h1 className={css.modalTitle}>
          <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
        </h1>
        <p className={css.modalMessage}>
          <FormattedMessage
            id="AuthenticationPage.verifyEmailText"
            values={{ email, newline: <br /> }}
          />
        </p>
        {resendErrorMessage}

        <div className={css.bottomWrapper}>
          <p className={css.modalHelperText}>
            {sendVerificationEmailInProgress ? (
              <FormattedMessage id="AuthenticationPage.sendingEmail" />
            ) : (
              <FormattedMessage id="AuthenticationPage.resendEmail" values={{ resendEmailLink }} />
            )}
          </p>
          <p className={css.modalHelperText}>
            <FormattedMessage id="AuthenticationPage.fixEmail" values={{ fixEmailLink }} />
          </p>
        </div>
      </div>
    );
    const formContent = isConfirm ? confirmForm : authenticationForms;

    const siteTitle = config.siteTitle;
    const hasReferralCode = signUpCode && checkIfReferralCode(signUpCode);
    const schemaTitle = hasReferralCode
      ? intl.formatMessage({ id: 'AuthenticationPage.referralCodeSchemaTitle' })
      : this.state.isLoginPage && tab === 'login'
      ? intl.formatMessage({ id: 'AuthenticationPage.schemaTitleLogin' }, { siteTitle })
      : intl.formatMessage({ id: 'AuthenticationPage.schemaTitleSignup' }, { siteTitle });

    const schemaDescription = hasReferralCode
      ? intl.formatMessage({ id: 'AuthenticationPage.referralCodeSchemaTitle' })
      : isLogin
      ? intl.formatMessage({ id: 'AuthenticationPage.schemaTitleSignup' }, { siteTitle })
      : intl.formatMessage({ id: 'AuthenticationPage.schemaDescriptionSignup' });

    const topbarClasses = classNames({
      [css.hideOnMobile]: showEmailVerification,
    });

    const loadingMsg = intl.formatMessage({ id: 'LoadingScreen.loadingMsg' });

    return (
      <Page
        title={schemaTitle}
        scrollingDisabled={scrollingDisabled}
        rootClassName={css.contentWrapper}
        description={schemaDescription}
        schema={{
          '@context': 'http://schema.org',
          '@type': 'WebPage',
          name: schemaTitle,
          description: schemaDescription,
        }}
      >
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            {/* <TopbarContainer className={topbarClasses} /> */}
          </LayoutWrapperTopbar>
          <LayoutWrapperMain className={css.layoutWrapperMain}>
            {isConfirm ? (
              <div className={css.confirmRoot}>
                <div className={css.confirmAuthPageContent}>
                  <div className={css.confirmLeftBannerImage}>
                    <img src={confirmLeftImage} alt="" />
                  </div>
                  <div className={css.confirmRightContent}>
                    {showEmailVerification && !isSignup ? emailVerificationContent : formContent}
                  </div>
                </div>
              </div>
            ) : (
              <div className={css.root}>
                <div className={css.authPageContent}>
                  <div className={css.leftBannerImage}>
                    <img src={leftImage} alt="Flexible Hosting" />
                  </div>
                  <div className={css.rightContent}>
                    {showEmailVerification && !isSignup ? emailVerificationContent : formContent}
                  </div>
                </div>
              </div>
            )}
            <Modal
              id="AuthenticationPage.tos"
              isOpen={this.state.tosModalOpen}
              onClose={() => this.setState({ tosModalOpen: false })}
              onManageDisableScrolling={onManageDisableScrolling}
            >
              <div className={css.termsWrapper}>
                <h2 className={css.termsHeading}>
                  <FormattedMessage id="AuthenticationPage.termsHeading" />
                </h2>
                <TermsOfService />
              </div>
            </Modal>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>{/* <Footer /> */}</LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

AuthenticationPageComponent.defaultProps = {
  currentUser: null,
  loginError: null,
  signupError: null,
  tab: 'signup',
  sendVerificationEmailError: null,
  confirmError: null,
};

const { bool, func, object, oneOf, shape } = PropTypes;

AuthenticationPageComponent.propTypes = {
  authInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  isAuthenticated: bool.isRequired,
  loginError: propTypes.error,
  scrollingDisabled: bool.isRequired,
  signupError: propTypes.error,
  submitLogin: func.isRequired,
  submitSignup: func.isRequired,
  tab: oneOf(['login', 'signup']),
  submitSignupStep1: func.isRequired,
  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  onResendVerificationEmail: func.isRequired,
  requestLogin: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  signupSuccess: bool.isRequired,
  confirmError: propTypes.error,
  // from withRouter
  location: shape({ state: object }).isRequired,
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const {
    isAuthenticated,
    loginError,
    signupError,
    signupSuccess,
    confirmError,
    signupStep1,
  } = state.Auth;
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    signupSuccess,
    signupStep1,
    scrollingDisabled: isScrollingDisabled(state),
    signupError,
    confirmError,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    state,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
  submitSignup: params => dispatch(signup(params, { requireCaptcha: true })),
  submitSignupStep1: params => dispatch(signupStep1Success(params)),
  submitUpdate: params => dispatch(update(params)),
  requestLogin: params => dispatch(loginRequest(params)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  submitSignupWithIdp: params => dispatch(signupWithIdp(params)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671

const AuthenticationPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AuthenticationPageComponent);

export default AuthenticationPage;
